export const HttpCodes = {
  Success: 200,
  Created: 201,
  Accepted: 202,
  NoContent: 204,
  BadRequest: 400,
  Unauthorized: 401,
  Forbidden: 403,
  NotFound: 404,
  Conflict: 409,
  InternalServerError: 500,
  UnprocessableEntity: 422,
  Expired: 410,
  PaymentFailed: 402,
};

const HomepageThemes = [
  {
    id: 1,
    name: "Homepage Theme One",
  },
];

export const AppName = "Aiserwave";
